<!--suppress AngularNgOptimizedImage -->
<div class="row clearfix profile-wrap">
  <!-- Panel izquierdo -->
  <div class="col-lg-4 col-md-12">
    <div class="card user-banner">
      <div class="banner">
        <!-- Avatar -->
        <div class="avatar">
          <ng-container *ngIf="userImage && userImage.trim() !== ''; else empleadoIcon">
            <img [src]="userImage" alt="Foto de Perfil">
          </ng-container>
          <ng-template #empleadoIcon>
            <img src="assets/images/empleado.png" alt="Empleado">
          </ng-template>
        </div>

        <!-- Info -->
        <div class="info">
          <div class="name">
            {{ user.nombres }} {{ user.primerApellido }} {{ user.segundoApellido }}
          </div>
          <div class="badge">
            <span *ngIf="user?.tipoUsuario as tipo">{{ tipo === 'Particular' ? 'MEDICO' : tipo }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Panel derecho -->
  <div class="col-lg-8 col-md-12">
    <div class="card profile-card">
      <mat-accordion multi="true" class="details-accordion">
        <!-- Datos generales (solo lectura) -->
        <mat-expansion-panel [expanded]="true" class="panel-soft">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="example-tab-icon msr-2">face</mat-icon>
              <span>INFORMACION DEL USUARIO: {{ user.usr }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <div class="section-title">
              <mat-icon>info</mat-icon>
              <span>GENERAL</span>
            </div>

            <div class="grid-2">
              <div class="datos-item">
                <div class="datos-label">NOMBRE COMPLETO</div>
                <div class="datos-valor">{{ user.nombres }} {{ user.primerApellido }} {{ user.segundoApellido }}</div>
              </div>

              <div class="datos-item">
                <div class="datos-label">TIPO DE USUARIO</div>
                <div class="datos-valor">{{ user.tipoUsuario === 'Particular' ? 'MEDICO' : user.tipoUsuario }}</div>
              </div>

              <div class="datos-item">
                <div class="datos-label">CORREO</div>
                <div class="datos-valor">{{ user.email }}</div>
              </div>

              <div class="datos-item">
                <div class="datos-label">TELEFONO</div>
                <div class="datos-valor">{{ user.movil | formatMobile }}</div>
              </div>

              <div class="datos-item full">
                <div class="datos-label">DOMICILIO</div>
                <div class="datos-valor">{{ user.domicilio }}</div>
              </div>

              <div class="datos-item">
                <div class="datos-label">CODIGO POSTAL</div>
                <div class="datos-valor">{{ user.codigoPostal }}</div>
              </div>

              <div class="datos-item">
                <div class="datos-label">MUNICIPIO</div>
                <div class="datos-valor">{{ user.municipio }}</div>
              </div>

              <div class="datos-item">
                <div class="datos-label">ASENTAMIENTO</div>
                <div class="datos-valor">{{ user.nombreAsentamiento }}</div>
              </div>

              <div class="datos-item" *ngIf="showBusinessGroupReadonly">
                <div class="datos-label">GRUPO EMPRESARIAL</div>
                <div class="datos-valor">{{ user.empresa }}</div>
              </div>

              <div class="datos-item">
                <div class="datos-label">{{ 'SUCURSAL' | regionWord }}</div>
                <div class="datos-valor">{{ user.nombreSucursal }}</div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- ========================= -->
        <!-- PERSONAS A CARGO (SOLO PACIENTE) -->
        <!-- ========================= -->
        @if (user.tipoUsuario === 'Paciente' || user.idTipoUsuario === UserRole.Paciente) {
          <!-- ✅ PERSONAS A CARGO (SOLO SI TIENE TUTORADOS) -->
          <mat-expansion-panel *ngIf="isTutor" class="panel-soft">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="example-tab-icon msr-2">groups</mat-icon>
                <span>PERSONAS A CARGO</span>
                <span class="count-chip">{{ tutorados.length }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">
              <div class="tutorados-grid">
                <button
                  type="button"
                  class="tutorado-card"
                  *ngFor="let row of tutorados"
                  (click)="openTutoradoProfile(row)"
                >
                  <div class="tutorado-header">
                    <div class="tutorado-header-row">
                      <img class="avatar avatar--sm" [src]="getTutoradoImageSrc(row)" alt="Paciente" />

                      <div class="tutorado-header-text">
                        <div class="tutorado-name">{{ getTutoradoNombre(row) || 'SIN NOMBRE' }}</div>

                        <div class="tutorado-badges">
                          <span class="badge" *ngIf="row?.fechaNacimiento">
                            <mat-icon>cake</mat-icon>
                            <span>NAC: {{ row.fechaNacimiento | date:'yyyy-MM-dd' }}</span>
                          </span>

                          <span class="badge" *ngIf="row?.genero">
                            <mat-icon>person</mat-icon>
                            <span>{{ row.genero === 'F' ? 'FEMENINO' : (row.genero === 'M' ? 'MASCULINO' : row.genero) }}</span>
                          </span>

                          <!-- ✅ PIN ACTIVO/INACTIVO si el endpoint lo trae -->
                          <span class="badge" *ngIf="row?.pinActivo !== undefined">
                            <mat-icon>{{ row?.pinActivo ? 'lock' : 'lock_open' }}</mat-icon>
                            <span>{{ row?.pinActivo ? 'PIN ACTIVO' : 'PIN INACTIVO' }}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="tutorado-body">
                    <div class="meta-row" *ngIf="row?.email">
                      <mat-icon>email</mat-icon>
                      <span class="meta-text break-anywhere">{{ row.email }}</span>
                    </div>

                    <div class="meta-row" *ngIf="row?.movil">
                      <mat-icon>phone</mat-icon>
                      <span class="meta-text">{{ row.movil | formatMobile }}</span>
                    </div>

                    <div class="meta-row" *ngIf="row?.domicilio">
                      <mat-icon>location_on</mat-icon>
                      <span class="meta-text">{{ row.domicilio }}</span>
                    </div>
                  </div>
                </button>
              </div>

              <div *ngIf="!tutorados.length" class="empty-list-message" style="height:auto;padding:16px;">
                NO HAY PACIENTES A CARGO
              </div>
            </div>
          </mat-expansion-panel>
        }

        <!-- ========================= -->
        <!-- PIN DEL PACIENTE (SOLO PACIENTE) -->
        <!-- ========================= -->
        @if (user.tipoUsuario === 'Paciente' || user.idTipoUsuario === UserRole.Paciente) {
          <mat-expansion-panel class="panel-soft pin-panel">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon class="example-tab-icon msr-2">pin</mat-icon>
                <span>PIN DE SEGURIDAD</span>
                <span class="pin-badge">OPCIONAL</span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="panel-content">

              <div class="pin-description">
                PUEDES USAR UN PIN DE 6 DÍGITOS PARA OCULTAR MEDICAMENTOS EN TUS RECETAS.
                <b>NO SE PUEDE ELIMINAR AQUÍ</b>; SOLO SE PUEDE CREAR O CAMBIAR VALIDANDO EL PIN ACTUAL.
              </div>

              <form [formGroup]="pinForm">

                <!-- ESTATUS -->
                <div class="pin-header-row">
                  <div class="pin-status">
                    <span class="pin-status-dot" [class.active]="pinExists"></span>
                    <span class="pin-status-text">
              {{ pinExists ? 'PIN ACTIVO' : 'SIN PIN' }}
            </span>
                  </div>
                </div>

                <!-- ========================= -->
                <!-- PIN ACTUAL (SOLO SI EXISTE) -->
                <!-- ========================= -->
                <div class="pin-body" *ngIf="pinExists">
                  <div class="pin-otp">
                    <div class="pin-otp-label">PIN ACTUAL (6 DÍGITOS)</div>

                    <div class="pin-otp-grid">
                      <input
                        #oldPinDigit
                        *ngFor="let _ of pinDigits; let i = index"
                        class="pin-otp-input"
                        type="password"
                        maxlength="1"
                        inputmode="numeric"
                        [value]="oldPinOtp[i]"
                        (input)="onOtpInput($event, i, 'old')"
                        (keydown)="onOtpKeyDown($event, i, 'old')"
                        (paste)="onOtpPaste($event, 'old')"
                      />
                    </div>

                    <!-- ACCIÓN: SE TE OLVIDÓ TU PIN -->
                    <div class="pin-forgot">
                      <a
                        class="pin-forgot-link"
                        matTooltip="Te enviaremos instrucciones a tu correo"
                        (click)="forgotPin()">
                        ¿SE TE OLVIDÓ TU PIN?
                      </a>
                    </div>

                    <div class="pin-otp-error" *ngIf="pinForm.get('oldPin')?.touched && pinForm.get('oldPin')?.invalid">
                      <span *ngIf="pinForm.get('oldPin')?.hasError('required')">EL PIN ACTUAL ES OBLIGATORIO.</span>
                      <span *ngIf="pinForm.get('oldPin')?.hasError('pinFormat')">DEBE SER DE 6 DÍGITOS NUMÉRICOS.</span>
                    </div>

                    <div class="pin-old-actions">
                      <button
                        mat-flat-button
                        color="primary"
                        type="button"
                        (click)="validateOldPin()"
                        [disabled]="validatingOldPin || !isOtpComplete('old')"
                        *ngIf="pinExists && !oldPinValidated">
                        VALIDAR PIN ACTUAL
                      </button>

                      <div *ngIf="pinExists && oldPinValidated" class="pin-ok">
                        PIN ACTUAL VALIDADO ✅
                      </div>
                    </div>

                  </div>
                </div>

                <!-- ========================= -->
                <!-- PIN NUEVO (SI NO EXISTE PIN O YA VALIDÓ EL ACTUAL) -->
                <!-- ========================= -->
                <div class="pin-body" *ngIf="!pinExists || oldPinValidated">
                  <div class="pin-otp">
                    <div class="pin-otp-label">
                      {{ pinExists ? 'PIN NUEVO (6 DÍGITOS)' : 'CREA TU PIN (6 DÍGITOS)' }}
                    </div>

                    <div class="pin-otp-grid">
                      <input
                        #newPinDigit
                        *ngFor="let _ of pinDigits; let i = index"
                        class="pin-otp-input"
                        type="password"
                        maxlength="1"
                        inputmode="numeric"
                        [value]="newPinOtp[i]"
                        (input)="onOtpInput($event, i, 'new')"
                        (keydown)="onOtpKeyDown($event, i, 'new')"
                        (paste)="onOtpPaste($event, 'new')"
                      />
                    </div>

                    <div class="pin-otp-hint">
                      SOLO NÚMEROS. NO REPITAS DÍGITOS Y EVITA SECUENCIAS (EJ: 123, 321). EJEMPLO VÁLIDO: 507194
                    </div>

                    <div class="pin-otp-error" *ngIf="pinForm.get('newPin')?.touched && pinForm.get('newPin')?.invalid">
                      <span *ngIf="pinForm.get('newPin')?.hasError('required')">EL PIN NUEVO ES OBLIGATORIO.</span>
                      <span *ngIf="pinForm.get('newPin')?.hasError('nipFormat')">DEBE SER DE 6 DÍGITOS NUMÉRICOS.</span>
                      <span *ngIf="pinForm.get('newPin')?.hasError('nipRepeated')">NO PUEDE REPETIR NÚMEROS.</span>
                      <span *ngIf="pinForm.get('newPin')?.hasError('nipSequence')">EVITA SECUENCIAS COMO 123 O 321.</span>
                    </div>
                  </div>
                </div>

                <!-- ========================= -->
                <!-- CONFIRMAR PIN NUEVO (SI NO EXISTE PIN O YA VALIDÓ EL ACTUAL) -->
                <!-- ========================= -->
                <div class="pin-body" *ngIf="!pinExists || oldPinValidated">
                  <div class="pin-otp">
                    <div class="pin-otp-label">CONFIRMAR PIN NUEVO (6 DÍGITOS)</div>

                    <div class="pin-otp-grid">
                      <input
                        #confirmNewPinDigit
                        *ngFor="let _ of pinDigits; let i = index"
                        class="pin-otp-input"
                        type="password"
                        maxlength="1"
                        inputmode="numeric"
                        [value]="confirmNewPinOtp[i]"
                        (input)="onOtpInput($event, i, 'confirm')"
                        (keydown)="onOtpKeyDown($event, i, 'confirm')"
                        (paste)="onOtpPaste($event, 'confirm')"
                      />
                    </div>

                    <div class="pin-otp-error"
                         *ngIf="(pinForm.get('confirmNewPin')?.touched && pinForm.get('confirmNewPin')?.invalid)
                    || (pinForm.touched && pinForm.hasError('pinMismatch'))">

                      <span *ngIf="pinForm.get('confirmNewPin')?.hasError('required')">CONFIRMA EL PIN NUEVO.</span>
                      <span *ngIf="pinForm.get('confirmNewPin')?.hasError('pinFormat')">DEBE SER DE 6 DÍGITOS NUMÉRICOS.</span>

                      <span *ngIf="pinForm.hasError('pinMismatch') && (pinForm.get('confirmNewPin')?.value?.length === 6)">
                        EL PIN NUEVO Y SU CONFIRMACIÓN NO COINCIDEN.
                      </span>
                    </div>
                  </div>
                </div>

                <!-- ACCIONES -->
                <div class="pin-actions">
                  <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    (click)="savePacientePin()"
                    [disabled]="pinForm.invalid || (pinExists && !oldPinValidated)">
                    {{ pinExists ? 'CAMBIAR PIN' : 'GUARDAR PIN' }}
                  </button>
                </div>

              </form>

            </div>
          </mat-expansion-panel>
        }

        <mat-expansion-panel class="panel-soft" *ngIf="showPiePaginaSection()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="example-tab-icon msr-2">description</mat-icon>
              <span>PIE DE PAGINA DE RECETA</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <form class="register-form" [formGroup]="piePaginaForm">

              <div class="pin-description">
                TEXTO DE DESLINDE O ACLARACION QUE APARECERA AL FINAL DE LA RECETA.
              </div>

              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>PIE DE PAGINA</mat-label>
                <textarea
                  matInput
                  rows="4"
                  formControlName="detalle"
                  autocomplete="off"
                  placeholder="Ejemplo: La indicacion medica debe seguirse bajo valoracion profesional y vigilancia clinica del paciente."></textarea>
              </mat-form-field>

              <div class="actions">
                <button
                  mat-flat-button
                  color="primary"
                  type="button"
                  (click)="savePiePagina()"
                  [disabled]="savingPiePagina || deletingPiePagina || loadingPiePagina">
                  {{ savingPiePagina ? 'GUARDANDO...' : piePaginaPrimaryActionLabel }}
                </button>

                <button
                  *ngIf="canDeletePiePagina"
                  mat-stroked-button
                  color="warn"
                  type="button"
                  (click)="deletePiePagina()"
                  [disabled]="deletingPiePagina || savingPiePagina || loadingPiePagina">
                  {{ deletingPiePagina ? 'ELIMINANDO...' : 'ELIMINAR PIE DE PAGINA' }}
                </button>
              </div>
            </form>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="panel-soft" *ngIf="showFormatoRecetaSection()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="example-tab-icon msr-2">article</mat-icon>
              <span>FORMATO DE RECETA</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <div class="pin-description">
              ELIGE EL FORMATO VISUAL QUE QUIERES USAR AL GENERAR TUS RECETAS.
            </div>

            <div class="formatos-empty" *ngIf="!loadingFormatosReceta && !formatosReceta.length">
              NO HAY FORMATOS DISPONIBLES POR EL MOMENTO.
            </div>

            <div class="formatos-grid" *ngIf="formatosReceta.length">
              <button
                type="button"
                class="formato-card"
                *ngFor="let formato of formatosReceta"
                [class.is-selected]="formatoRecetaSeleccionadoId === formato.idFormatoReceta"
                [class.is-active]="formatoRecetaActivoId === formato.idFormatoReceta"
                (click)="selectFormatoReceta(formato.idFormatoReceta)">

                <div class="formato-card__header">
                  <div>
                    <div class="formato-card__title">FORMATO {{ formato.idFormatoReceta }}</div>
                    <div class="formato-card__subtitle">
                      {{ formatoRecetaActivoId === formato.idFormatoReceta ? 'ACTIVO' : 'DISPONIBLE' }}
                    </div>
                  </div>

                  <div class="formato-card__chips">
                    <span class="formato-chip formato-chip--active" *ngIf="formatoRecetaActivoId === formato.idFormatoReceta">
                      ACTUAL
                    </span>
                    <span class="formato-chip formato-chip--selected" *ngIf="formatoRecetaSeleccionadoId === formato.idFormatoReceta && formatoRecetaActivoId !== formato.idFormatoReceta">
                      SELECCIONADO
                    </span>
                    <button
                      *ngIf="formato.imagenVistaPrevia"
                      type="button"
                      class="formato-preview-open"
                      (click)="openFormatoRecetaPreview(formato, $event)">
                      <mat-icon>zoom_in</mat-icon>
                      <span>VER</span>
                    </button>
                  </div>
                </div>

                <div class="formato-card__preview">
                  <img
                    *ngIf="formato.imagenVistaPrevia; else formatoPlaceholder"
                    class="formato-preview-image"
                    [src]="formato.imagenVistaPrevia"
                    alt="Vista previa del formato de receta" />

                  <ng-template #formatoPlaceholder>
                    <div class="formato-preview-placeholder">
                      <mat-icon>image_not_supported</mat-icon>
                      <span>SIN VISTA PREVIA</span>
                    </div>
                  </ng-template>
                </div>
              </button>
            </div>

            <div class="actions">
              <button
                mat-flat-button
                color="primary"
                type="button"
                (click)="saveFormatoReceta()"
                [disabled]="loadingFormatosReceta || savingFormatoReceta || !canSaveFormatoReceta">
                {{ savingFormatoReceta ? 'GUARDANDO...' : 'GUARDAR FORMATO DE RECETA' }}
              </button>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel class="panel-soft" *ngIf="showHipSection()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="example-tab-icon msr-2">medical_information</mat-icon>
              <span>FORMATO HIP</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="panel-content">
            <div class="pin-description">
              ELIGE EL FORMATO VISUAL QUE QUIERES USAR AL GENERAR LA HIP.
            </div>

            <div class="formatos-empty" *ngIf="!loadingFormatosHip && !formatosHip.length">
              NO HAY FORMATOS HIP DISPONIBLES POR EL MOMENTO.
            </div>

            <div class="formatos-grid" *ngIf="formatosHip.length">
              <button
                type="button"
                class="formato-card"
                *ngFor="let formato of formatosHip"
                [class.is-selected]="formatoHipSeleccionadoId === formato.idFormatoHip"
                [class.is-active]="formatoHipActivoId === formato.idFormatoHip"
                (click)="selectFormatoHip(formato.idFormatoHip)">

                <div class="formato-card__header">
                  <div>
                    <div class="formato-card__title">FORMATO {{ formato.idFormatoHip }}</div>
                    <div class="formato-card__subtitle">
                      {{ formatoHipActivoId === formato.idFormatoHip ? 'ACTIVO' : 'DISPONIBLE' }}
                    </div>
                  </div>

                  <div class="formato-card__chips">
                    <span class="formato-chip formato-chip--active" *ngIf="formatoHipActivoId === formato.idFormatoHip">
                      ACTUAL
                    </span>
                    <span class="formato-chip formato-chip--selected" *ngIf="formatoHipSeleccionadoId === formato.idFormatoHip && formatoHipActivoId !== formato.idFormatoHip">
                      SELECCIONADO
                    </span>
                    <button
                      *ngIf="formato.imagenVistaPrevia"
                      type="button"
                      class="formato-preview-open"
                      (click)="openFormatoHipPreview(formato, $event)">
                      <mat-icon>zoom_in</mat-icon>
                      <span>VER</span>
                    </button>
                  </div>
                </div>

                <div class="formato-card__preview">
                  <img
                    *ngIf="formato.imagenVistaPrevia; else formatoHipPlaceholder"
                    class="formato-preview-image"
                    [src]="formato.imagenVistaPrevia"
                    alt="Vista previa del formato HIP" />

                  <ng-template #formatoHipPlaceholder>
                    <div class="formato-preview-placeholder">
                      <mat-icon>image_not_supported</mat-icon>
                      <span>SIN VISTA PREVIA</span>
                    </div>
                  </ng-template>
                </div>
              </button>
            </div>

            <div class="actions">
              <button
                mat-flat-button
                color="primary"
                type="button"
                (click)="saveFormatoHip()"
                [disabled]="loadingFormatosHip || savingFormatoHip || !canSaveFormatoHip">
                {{ savingFormatoHip ? 'GUARDANDO...' : 'GUARDAR FORMATO HIP' }}
              </button>
            </div>
          </div>
        </mat-expansion-panel>

        <ng-template #formatoRecetaPreviewDialog>
          <div class="formato-modal" *ngIf="formatoRecetaPreviewActual as formato">
            <div class="formato-modal__header">
              <div>
                <div class="formato-modal__title">FORMATO {{ formato.idFormatoReceta }}</div>
                <div class="formato-modal__subtitle">VISTA PREVIA AMPLIADA</div>
              </div>

              <button type="button" class="formato-modal__close" (click)="closeFormatoRecetaPreview()">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="formato-modal__body">
              <img
                class="formato-modal__image"
                [src]="formato.imagenVistaPrevia"
                alt="Vista previa ampliada del formato de receta" />
            </div>
          </div>
        </ng-template>

        <ng-template #formatoHipPreviewDialog>
          <div class="formato-modal" *ngIf="formatoHipPreviewActual as formato">
            <div class="formato-modal__header">
              <div>
                <div class="formato-modal__title">FORMATO {{ formato.idFormatoHip }}</div>
                <div class="formato-modal__subtitle">VISTA PREVIA AMPLIADA</div>
              </div>

              <button type="button" class="formato-modal__close" (click)="closeFormatoHipPreview()">
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="formato-modal__body">
              <img
                class="formato-modal__image"
                [src]="formato.imagenVistaPrevia"
                alt="Vista previa ampliada del formato HIP" />
            </div>
          </div>
        </ng-template>

        <!-- Configuracion / edicion -->
        <mat-expansion-panel class="panel-soft">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon class="example-tab-icon msr-2">settings</mat-icon>
              <span>CONFIGURACION</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- FORM WRAP -->
          <div class="panel-content">
            @switch (user.tipoUsuario) {

              @case (UserRole.Admin) {
                <form class="register-form" [formGroup]="userForm">

                  <div class="section-title">
                    <mat-icon>manage_accounts</mat-icon>
                    <span>DATOS PRINCIPALES</span>
                  </div>

                  <div class="grid-2">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>TIPO DE USUARIO</mat-label>
                      <mat-select formControlName="idTipoUsuario">
                        <mat-option *ngFor="let row of roles" [value]="row.value">{{ row.name }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div></div>

                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>USUARIO</mat-label>
                      <input matInput formControlName="usr" autocomplete="nope" aria-autocomplete="none"/>
                    </mat-form-field>

                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>CORREO ELECTRONICO</mat-label>
                      <input matInput formControlName="email" autocomplete="nope" aria-autocomplete="none"/>
                    </mat-form-field>
                  </div>

                  <div class="section-divider"></div>

                  <div class="section-title">
                    <mat-icon>home</mat-icon>
                    <span>CONTACTO Y DOMICILIO</span>
                  </div>

                  <div class="grid-2">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>NOMBRE(S)</mat-label>
                      <input matInput formControlName="nombres" autocomplete="nope" aria-autocomplete="none"/>
                    </mat-form-field>

                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>PRIMER APELLIDO</mat-label>
                      <input matInput formControlName="primerApellido" autocomplete="nope" aria-autocomplete="none"/>
                    </mat-form-field>

                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>SEGUNDO APELLIDO</mat-label>
                      <input matInput formControlName="segundoApellido" autocomplete="nope" aria-autocomplete="none"/>
                    </mat-form-field>

                    <mat-form-field *ngIf="userForm.get('movil')" class="example-full-width" appearance="outline">
                      <mat-label>TELEFONO</mat-label>
                      <ngx-mat-intl-tel-input
                        formControlName="movil"
                        [preferredCountries]="preferredCountries"
                        [enablePlaceholder]="true">
                      </ngx-mat-intl-tel-input>
                    </mat-form-field>

                    <mat-form-field class="example-full-width full" appearance="outline">
                      <mat-label>DIRECCION</mat-label>
                      <textarea matInput formControlName="domicilio" autocomplete="nope" aria-autocomplete="none"></textarea>
                    </mat-form-field>
                  </div>

                  <div class="section-divider"></div>

                  <div class="section-title">
                    <mat-icon>location_on</mat-icon>
                    <span>{{ 'CODIGO POSTAL Y COLONIA' | regionWord }}</span>
                  </div>

                  <mat-form-field class="example-full-width" appearance="outline">
                    <mat-label>{{ (userForm.get('settlementSearch')?.value ? 'COLONIA' : 'CODIGO POSTAL') | regionWord }}</mat-label>
                    <input matInput [matAutocomplete]="auto"
                           formControlName="settlementSearch"
                           (blur)="onSettlementBlur()"
                           (keydown)="searchSettlementsByKeyPress($event)"
                           autocomplete="nope" aria-autocomplete="none"/>
                    <mat-autocomplete #auto="matAutocomplete"
                                      [displayWith]="displayFn"
                                      (optionSelected)="setSelectedSettlement($event.option.value)">
                      @for (option of settlements; track option) {
                        <mat-option [value]="option">
                          {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>

                  <div class="section-divider"></div>

                  <div class="section-title">
                    <mat-icon>business</mat-icon>
                    <span>EMPRESA</span>
                  </div>

                  <div class="grid-2">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>GRUPO EMPRESARIAL</mat-label>
                      <mat-select formControlName="idGEMP" (selectionChange)="getBranchesByGemp()">
                        <mat-option *ngFor="let row of businessGroups" [value]="row.idGEMP">{{ row.nombre }}</mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>{{ 'SUCURSAL' | regionWord }}</mat-label>
                      <mat-select formControlName="idSucursal">
                        <mat-option *ngFor="let row of branches" [value]="row.idSucursal">{{ row.nombre }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="actions">
                    <button mat-flat-button color="primary" type="button" (click)="confirmAdd()">
                      GUARDAR CAMBIOS
                    </button>
                  </div>

                </form>
              }

              @default {
                <form class="register-form" [formGroup]="userForm">

                  <div class="section-title">
                    <mat-icon>contact_mail</mat-icon>
                    <span>CONTACTO</span>
                  </div>

                  <div class="grid-2">
                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>CORREO ELECTRONICO</mat-label>
                      <input matInput formControlName="email" autocomplete="nope" aria-autocomplete="none"/>
                    </mat-form-field>

                    <mat-form-field *ngIf="userForm.get('movil')" class="example-full-width" appearance="outline">
                      <mat-label>TELEFONO</mat-label>
                      <ngx-mat-intl-tel-input
                        formControlName="movil"
                        [preferredCountries]="preferredCountries"
                        [enablePlaceholder]="true">
                      </ngx-mat-intl-tel-input>
                    </mat-form-field>

                    <mat-form-field class="example-full-width full" appearance="outline">
                      <mat-label>DIRECCION</mat-label>
                      <textarea matInput formControlName="domicilio" autocomplete="nope" aria-autocomplete="none"></textarea>
                    </mat-form-field>
                  </div>

                  <div class="actions">
                    <button mat-flat-button color="primary" type="button" (click)="confirmAdd()">
                      GUARDAR CAMBIOS
                    </button>
                  </div>

                </form>
              }
            }
          </div>
        </mat-expansion-panel>

      </mat-accordion>
    </div>
  </div>
</div>
